module.exports = __webpack_public_path__ + "img/list-back-2.2c19cdc6.gif";